export var BonusMessageType;
(function (BonusMessageType) {
    BonusMessageType["FreeBet"] = "freebet";
    BonusMessageType["Combo"] = "combo";
    BonusMessageType["Tax"] = "tax";
})(BonusMessageType || (BonusMessageType = {}));
//# sourceMappingURL=BonusMessageType.js.map